import {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {useUserDevice} from "@pg-mono/user-device";

import {ChatBotDotsAnimation} from "../../../atoms/chat_bot/ChatBotDotsAnimation";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppSelector} from "../../../store/hooks";
import {usePostSemanticSearchMutation} from "../../api/post_semantic_search_api";
import {postSemanticSearchCacheKey} from "../../constants/post_semantic_search_cache_key";
import {useOfferSignupStatus} from "../../hooks/use_offer_signup_status";
import {useSemanticSearchConversationScroll} from "../../hooks/use_semantic_search_conversation_scroll";
import {useSemanticSearchLocalStorage} from "../../hooks/use_semantic_search_local_storage";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {SemanticSearchPropertyList} from "../semantic_search_property_list/SemanticSearchPropertyList";
import {SemanticSearchSignup} from "../semantic_search_sidebar/SemanticSearchSignup";
import {SemanticSearchConversationMessage} from "./SemanticSearchConversationMessage";

interface Props {
    containerRef?: RefObject<HTMLDivElement | null>;
}

export const SemanticSearchConversation = ({containerRef}: Props) => {
    const {isMobile} = useUserDevice();

    const {history: semanticSearchHistory} = useSemanticSearchLocalStorage();
    const [_, {isLoading}] = usePostSemanticSearchMutation({fixedCacheKey: postSemanticSearchCacheKey});
    const {isUserLoggedIn} = useShouldHidePrices();

    const {lastUserMessageRef, lastApiResponseRef, lastUserInputIndex, lastApiResponseIndex} = useSemanticSearchConversationScroll(semanticSearchHistory, {
        containerRef
    });

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    const offerSignupStatus = useOfferSignupStatus(semanticSearchHistory);

    if (!hasConversation) return null;

    return (
        <div className={cx(semanticSearchConversationWrapper, isMobile && css({mt: 3}))}>
            <div className={semanticSearchConversation}>
                <div className={semanticSearchConversationList}>
                    {semanticSearchHistory?.map((item, historyIndex) => {
                        const isLastUserMessage = historyIndex === lastUserInputIndex;
                        const isLastApiResponse = historyIndex === lastApiResponseIndex;

                        if (item.type === "USER_INPUT") {
                            return (
                                <div key={historyIndex} ref={isLastUserMessage ? lastUserMessageRef : undefined}>
                                    <SemanticSearchConversationMessage variant="user" text={item.text} />
                                </div>
                            );
                        }

                        return (
                            <div key={historyIndex} ref={isLastApiResponse ? lastApiResponseRef : undefined} className={apiMessageWrap}>
                                <SemanticSearchConversationMessage variant="api" text={item.text} />

                                <SemanticSearchPropertyList properties={item.results} filters={item.filters} count={item.count} />
                            </div>
                        );
                    })}

                    {offerSignupStatus && !isUserLoggedIn && <SemanticSearchSignup />}

                    {isLoading && (
                        <div className={loadingWrap}>
                            <ChatBotDotsAnimation />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const semanticSearchConversationWrapper = css({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    px: 1.5
});

const semanticSearchConversation = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "744px",
    my: 3,
    mx: 1.5,
    minWidth: 0
});

const semanticSearchConversationList = css({
    listStyleType: "none",
    m: 0,
    p: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const apiMessageWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0
});

const loadingWrap = css({
    py: 2
});
import {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {useUserDevice} from "@pg-mono/user-device";

import {ChatBotDotsAnimation} from "../../../atoms/chat_bot/ChatBotDotsAnimation";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppSelector} from "../../../store/hooks";
import {usePostSemanticSearchMutation} from "../../api/post_semantic_search_api";
import {postSemanticSearchCacheKey} from "../../constants/post_semantic_search_cache_key";
import {useOfferSignupStatus} from "../../hooks/use_offer_signup_status";
import {useSemanticSearchConversationScroll} from "../../hooks/use_semantic_search_conversation_scroll";
import {useSemanticSearchLocalStorage} from "../../hooks/use_semantic_search_local_storage";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {SemanticSearchPropertyList} from "../semantic_search_property_list/SemanticSearchPropertyList";
import {SemanticSearchSignup} from "../semantic_search_sidebar/SemanticSearchSignup";
import {SemanticSearchConversationMessage} from "./SemanticSearchConversationMessage";

interface Props {
    containerRef?: RefObject<HTMLDivElement | null>;
}

export const SemanticSearchConversation = ({containerRef}: Props) => {
    const {isMobile} = useUserDevice();

    const {history: semanticSearchHistory} = useSemanticSearchLocalStorage();
    const [_, {isLoading}] = usePostSemanticSearchMutation({fixedCacheKey: postSemanticSearchCacheKey});
    const {isUserLoggedIn} = useShouldHidePrices();

    const {lastUserMessageRef, lastApiResponseRef, lastUserInputIndex, lastApiResponseIndex} = useSemanticSearchConversationScroll(semanticSearchHistory, {
        containerRef
    });

    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);

    const offerSignupStatus = useOfferSignupStatus(semanticSearchHistory);

    if (!hasConversation) return null;

    return (
        <div className={cx(semanticSearchConversationWrapper, isMobile && css({mt: 3}))}>
            <div className={semanticSearchConversation}>
                <div className={semanticSearchConversationList}>
                    {semanticSearchHistory?.map((item, historyIndex) => {
                        const isLastUserMessage = historyIndex === lastUserInputIndex;
                        const isLastApiResponse = historyIndex === lastApiResponseIndex;

                        if (item.type === "USER_INPUT") {
                            return (
                                <div key={historyIndex} ref={isLastUserMessage ? lastUserMessageRef : undefined}>
                                    <SemanticSearchConversationMessage variant="user" text={item.text} />
                                </div>
                            );
                        }

                        return (
                            <div key={historyIndex} ref={isLastApiResponse ? lastApiResponseRef : undefined} className={apiMessageWrap}>
                                <SemanticSearchConversationMessage variant="api" text={item.text} />

                                <SemanticSearchPropertyList properties={item.results} filters={item.filters} count={item.count} />
                            </div>
                        );
                    })}

                    {offerSignupStatus && !isUserLoggedIn && <SemanticSearchSignup />}

                    {isLoading && (
                        <div className={loadingWrap}>
                            <ChatBotDotsAnimation />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const semanticSearchConversationWrapper = css({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    px: 1.5
});

const semanticSearchConversation = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "744px",
    my: 3,
    mx: 1.5,
    minWidth: 0
});

const semanticSearchConversationList = css({
    listStyleType: "none",
    m: 0,
    p: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const apiMessageWrap = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0
});

const loadingWrap = css({
    py: 2
});
